import Api from "../helpers/api";

export const vratDatagridData = async (data) => {
  try {
    const tab = data.get.tab ? `${data.get.tab}/` : "";
    const response = await Api.post(
      `/api/v1/smartmap/datatable/${data.get.type}/${tab}${data.get.id}`,
      data.post
    );
    return response || false;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Ziska data, ktore je potrebne zaroven stiahnut ako subor
 * Uzivatelovi rovno ponukne stiahnute suboru
 * @param {object} data
 * @param {string} fileName
 * @returns
 */
export const vratDatagridDataDownload = async (data, fileName) => {
  try {
    const tab = data.get.tab ? `${data.get.tab}/` : "";
    const response = await Api.post(
      `/api/v1/smartmap/datatable/${data.get.type}/${tab}${data.get.id}`,
      data.post,
      fileName
    );
    return response || false;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Ziska data, ktore je potrebne zaroven stiahnut ako subor
 * Uzivatelovi rovno ponukne stiahnute suboru
 * @param {object} data
 * @param {string} fileName
 * @returns
 */
export const vratExportLv = async (data, fileName) => {
  try {
    const tab = data.get.tab ? `${data.get.tab}/` : "";
    const response = await Api.post(
      `/api/v1/smartmap/datatable/exportlv/${data.get.id}`,
      data.post,
      fileName
    );
    return response || false;
  } catch (error) {
    console.error(error);
  }
};
